import { render, staticRenderFns } from "./LoansAdmin.vue?vue&type=template&id=60088857"
import script from "./LoansAdmin.vue?vue&type=script&lang=js"
export * from "./LoansAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports